import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Select,
  Spin,
  notification,
} from "antd";

import React, { useState, useEffect, useCallback } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import AllergensApi from "../../common/Apis/AllergensApi";
import CoolingShelfApi from "../../common/Apis/CoolingShelfApi";
import { AudioOutlined, LoadingOutlined } from "@ant-design/icons";

const EditCoolingShelf = () => {
  const navigate = useNavigate();
  const [formAdd] = Form.useForm();
  const [form] = Form.useForm();
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  const [SingleCooling, setSingleCooling] = useState(null);
  const getSingleCooling = useCallback(() => {
    CoolingShelfApi.SingleCoolingProcess(id)
      .then((response) => {
        console.log(response?.payload)
        setSingleCooling(response?.payload)
        formAdd.setFieldsValue({
          period: response?.payload?.period,
          periodType: response?.payload?.periodType,
          temperatureInCelsius: response?.payload?.temperatureInCelsius,
        });

      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  useEffect(() => {
    PageLoading();
    getSingleCooling();
  }, [PageLoading, getSingleCooling]);

  const [isRecording, setIsRecording] = useState(false);
  const [isRecording2, setIsRecording2] = useState(false);
  const startRecording = (fieldN) => {

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      let fieldName = fieldN;

      formAdd.setFieldsValue({
        [fieldName]: transcript,
      });
    };

    recognition.start();
    if (fieldN === 'temperatureMinInCelsius') {
      setIsRecording(true);
    } else if (fieldN === 'temperatureMaxInCelsius') {
      setIsRecording2(true);
    }
  };
  const validateInputNumber = (_, value) => {
    if (value >= 0) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Value must be greater than to 0"));
  };

  const validateInputNumberNew = (_, value) => {

    if (!isNaN(value) && value >= -5) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Value must be greater than to -5"));
  };

  const stopRecording = () => {
    setIsRecording(false);
    setIsRecording2(false);
  };
  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      id: SingleCooling?.id,
      period: data?.period,
      periodType: data?.periodType,
      temperatureInCelsius: data?.temperatureInCelsius,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    })


    CoolingShelfApi.PutCoolingShelf(id, formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/Cooling-Shelf");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });

  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            form={formAdd}
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="period"
                    label="Period"
                    className="text-lable disabled"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Period",
                      },
                      { validator: validateInputNumber },
                    ]}
                  >
                    <Input
                      type="number"
                      min={0}
                      disabled
                      placeholder="Period"
                      className="control-input"
                    />
                  </Form.Item>
                  <p style={{ color: "#3D54A4" }}>Period should be entered as a number. Ex : 1, 2, 3, 4</p>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="periodType"
                    label="Period Type"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Period Type",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select"
                      placeholder="Select Period Type"
                    >
                      <option value={"DAYS"}>Days</option>
                      <option value={"WEEKS"}>Weeks</option>
                      <option value={"MONTHS"}>Months</option>
                      <option value={"YEARS"}>Years</option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="temperatureInCelsius"
                    label="Temperature"
                    className="text-lable"
                    rules={[

                      { validator: validateInputNumberNew },
                    ]}
                  >
                    <Input
                      type="number"
                      step="0.01"
                      min="-5"
                      className="control-input"
                      style={{
                        border: 'none',
                        textAlign: 'end',
                        padding: '0px'
                      }}
                      addonAfter={
                        <>
                          <Button
                            className="StockTempClass"
                            style={{
                              border: 'none',
                              padding: 0,
                              paddingTop: '0px',
                              margin: 0,
                              background: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            'C
                          </Button>
                          <Button
                            onMouseDown={() => startRecording('temperatureMinInCelsius')}
                            onMouseUp={stopRecording}
                            onMouseLeave={stopRecording}
                            style={{
                              border: 'none',
                              padding: 0,
                              margin: 0,
                              marginLeft: '10px',
                              paddingLeft: '5px',
                              paddingBottom: '5px',
                              background: 'none',
                              borderRadius: '0px',
                              borderLeft: '1px solid #d9d9d9',
                              cursor: 'pointer',
                            }}
                          >
                            {isRecording ? <LoadingOutlined /> : <AudioOutlined />}
                          </Button>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Update {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default EditCoolingShelf;
